import { render, staticRenderFns } from "./RegionMultiplePickerInput.vue?vue&type=template&id=6450d012&scoped=true&"
import script from "./RegionMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./RegionMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450d012",
  null
  
)

export default component.exports